/* Code for Slick Slider - Multi Column - Redefine*/
$(document).ready(function () {
  $('.rd-slickslider-1').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    prevArrow:
      '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="12.158" height="11.85" viewBox="0 0 12.158 11.85"><path d="M6.985,13.7l-.6.6a.649.649,0,0,1-.92,0L.188,9.034a.649.649,0,0,1,0-.92L5.463,2.839a.649.649,0,0,1,.92,0l.6.6a.652.652,0,0,1-.011.931L3.7,7.487h7.8a.65.65,0,0,1,.651.651v.868a.65.65,0,0,1-.651.651H3.7l3.27,3.115A.647.647,0,0,1,6.985,13.7Z" transform="translate(0.004 -2.647)" fill="#212121"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="12.158" height="11.85" viewBox="0 0 12.158 11.85"><path d="M6.985,13.7l-.6.6a.649.649,0,0,1-.92,0L.188,9.034a.649.649,0,0,1,0-.92L5.463,2.839a.649.649,0,0,1,.92,0l.6.6a.652.652,0,0,1-.011.931L3.7,7.487h7.8a.65.65,0,0,1,.651.651v.868a.65.65,0,0,1-.651.651H3.7l3.27,3.115A.647.647,0,0,1,6.985,13.7Z" transform="translate(0.004 -2.647)" fill="#212121"/></svg></svg></div>',
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $('.rd-slickslider-2').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 300,
    dots: true,
    prevArrow:
      '<div class="slick-prev"><svg width="21.127" height="17.226" viewBox="0 0 21.127 17.226"><path d="M8.519,17.226a1.2,1.2,0,0,0,.865-2.031L4.072,9.868H19.928a1.2,1.2,0,0,0,0-2.4H4.027S9.413,2.09,9.5,2a1.2,1.2,0,0,0-.894-2,1.2,1.2,0,0,0-.887.392L.353,7.762A1.2,1.2,0,0,0,0,8.611a1.268,1.268,0,0,0,.351.937L7.7,16.9a1.178,1.178,0,0,0,.818.322" transform="translate(0 0)" fill="currentColor" /></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg width="21.127" height="17.226" viewBox="0 0 21.127 17.226"><path d="M12.608,17.226a1.2,1.2,0,0,1-.865-2.031l5.312-5.327H1.2a1.2,1.2,0,0,1,0-2.4H17.1S11.714,2.09,11.627,2a1.2,1.2,0,0,1,.894-2,1.2,1.2,0,0,1,.887.392l7.366,7.37a1.2,1.2,0,0,1,.353.849,1.268,1.268,0,0,1-.351.937L13.426,16.9a1.178,1.178,0,0,1-.818.322"  fill="currentColor" /></svg></div>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $('.rd-slickslider-3').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    dots: false,
    prevArrow:
      '<div class="slick-prev"><svg width="21.127" height="17.226" viewBox="0 0 21.127 17.226"><path d="M8.519,17.226a1.2,1.2,0,0,0,.865-2.031L4.072,9.868H19.928a1.2,1.2,0,0,0,0-2.4H4.027S9.413,2.09,9.5,2a1.2,1.2,0,0,0-.894-2,1.2,1.2,0,0,0-.887.392L.353,7.762A1.2,1.2,0,0,0,0,8.611a1.268,1.268,0,0,0,.351.937L7.7,16.9a1.178,1.178,0,0,0,.818.322" transform="translate(0 0)" fill="currentColor" /></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg width="21.127" height="17.226" viewBox="0 0 21.127 17.226"><path d="M12.608,17.226a1.2,1.2,0,0,1-.865-2.031l5.312-5.327H1.2a1.2,1.2,0,0,1,0-2.4H17.1S11.714,2.09,11.627,2a1.2,1.2,0,0,1,.894-2,1.2,1.2,0,0,1,.887.392l7.366,7.37a1.2,1.2,0,0,1,.353.849,1.268,1.268,0,0,1-.351.937L13.426,16.9a1.178,1.178,0,0,1-.818.322"  fill="currentColor" /></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $('.rd-slickslider-4').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $('.rd-slickslider-10').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 1000,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0686/0587/0386/files/MicrosoftTeams-image_10.png?v=1692974772">',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0686/0587/0386/files/MicrosoftTeams-image_8_17ad3547-35e2-4fbe-87c4-a67f81f9b67b.png?v=1692974773">',
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  });
  $('.rd-slickslider-12').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 1000,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0686/0587/0386/files/MicrosoftTeams-image_10.png?v=1692974772">',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0686/0587/0386/files/MicrosoftTeams-image_8_17ad3547-35e2-4fbe-87c4-a67f81f9b67b.png?v=1692974773">',
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  });

  $('.rd-logo-slickslider').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 2500,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    prevArrow:
      '<div class="slick-prev"><img role="presentation" alt="Arrow Left" src="https://cdn.shopify.com/s/files/1/0686/0587/0386/files/caurosel-arrow-left.svg?v=1719484407" loading="lazy">',
    nextArrow:
      '<div class="slick-next"><img role="presentation" alt="Arrow Right" src="https://cdn.shopify.com/s/files/1/0686/0587/0386/files/caurosel-arrow-right.svg?v=1719484407" loading="lazy">',
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  });

  $('.rd-slider-mobile').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 1000,
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 991,
        settings: {
          centerMode: false,
          variableWidth: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
